/* eslint-disable no-undef */
// Modules
import React, { useEffect } from 'react'
import { Button, TextField, Typography } from '@dasa-health/components-react'
import { ButtonIcon, Spacing, ThemeProvider, Box, Flex } from '@dasa-health/alma-react'

// Components
import { TemplateContainer } from 'redesign/components/templates'

// Application
import { CustomSpacing } from './styles'
import { ArrowLeft } from '@dasa-health/alma-icons'
import { useHistory } from 'react-router-dom'
import { usePhasedLogin } from 'redesign/hooks/usePhasedLogin'
import { CustomForm } from '../CPFPhasedLoginForm/styles'
import { SystemBoldViewon, SystemBoldViewoff } from '@dasa-health/icons'
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'
import { useCampaigns } from 'redesign/hooks/useCampaigns'
import { useCustomLayoutStore } from 'redesign/store'

export const MobileServiceLogin = () => {
    const { dispatchAnalytics } = usePhasedLogin()
    const {
        values,
        errors,
        touched,
        handleBlur,
        viewPassword,
        handleSubmit,
        handleChange,
        isSubmitting,
        handleChangeCpf,
        handleViewPassword,
        redirectToForgotPassword,
    } = useCPFLoginForm()
    const { changeCampaingSessionStorage } = useCampaigns()

    useEffect(() => {
        const step = values.showPasswordField ? 'insert_password' : 'insert_cpf'
        dispatchAnalytics(step)
    }, [dispatchAnalytics, values.showPasswordField])

    useEffect(() => {
        changeCampaingSessionStorage()
    }, [changeCampaingSessionStorage])
    const { layoutConfig } = useCustomLayoutStore()
    const { goBack } = useHistory()

    return (
        <TemplateContainer renderHeader>
            <ThemeProvider>
                <Box height="56px">
                    <ButtonIcon color="#000" leadingIcon={<ArrowLeft />} marginLeft="-16px" onClick={() => goBack()} />
                </Box>
            </ThemeProvider>

            <CustomSpacing />
            <Typography as="h1" size={4} sx={{ fontWeight: '700' }}>
                {layoutConfig?.title}
            </Typography>
            <Spacing height={16} />
            <Typography as="h2" size={1} weight={400}>
                {layoutConfig?.description}{' '}
            </Typography>
            <CustomForm onSubmit={handleSubmit}>
                <Flex flexDirection="column" height="100%">
                    <TextField
                        autoComplete="username"
                        className="textInput"
                        helperText={touched.cpf ? errors.cpf : ''}
                        inputMode="numeric"
                        label="Digite o CPF para acessar ou cadastrar"
                        name="cpf"
                        onBlur={handleBlur}
                        onChange={handleChangeCpf}
                        readOnly={isSubmitting}
                        type="tel"
                        value={values.cpf}
                        variant={touched.cpf && errors.cpf ? 'error' : 'default'}
                    />
                    <Spacing height={24 + 32} />
                    {values.showPasswordField && (
                        <>
                            <TextField
                                className="textInput"
                                helperText={touched.password ? errors.password : ''}
                                label="Senha"
                                name="password"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                readOnly={isSubmitting}
                                trailingIcon={
                                    viewPassword ? (
                                        <SystemBoldViewoff data-testid="change-type-input" onClick={handleViewPassword} />
                                    ) : (
                                        <SystemBoldViewon data-testid="change-type-input" onClick={handleViewPassword} />
                                    )
                                }
                                type={viewPassword ? 'text' : 'password'}
                                value={values.password}
                                variant={touched.password && errors.password ? 'error' : 'default'}
                            />
                            <Spacing height={16 + 18} />
                            <Button
                                data-current-service="Login faseado"
                                data-item-position="Login CPF"
                                data-item-text="Esqueci a senha"
                                onClick={() => redirectToForgotPassword(values.cpf)}
                                size="compact"
                                type="button"
                                variant="tertiary"
                                width="100%"
                            >
                                Esqueci a senha
                            </Button>
                            <Spacing height={16 + 18} />
                        </>
                    )}
                    <Flex flexDirection="column" marginTop={'initial'}>
                        <Button
                            disabled={!values.cpf || (!values.showPasswordField && !!errors.cpf) || isSubmitting}
                            isLoading={isSubmitting}
                            width="100%"
                        >
                            Continuar
                        </Button>
                        <Spacing height={26} />
                    </Flex>
                </Flex>
            </CustomForm>
        </TemplateContainer>
    )
}
